import { Injectable, NgZone } from '@angular/core';
import {
  Renderer,
  RendererOptions,
  RendererViewStyle,
} from '@hi-level/2d-renderer';
import { Subject } from 'rxjs';

@Injectable()
export class FloorRenderingService {
  public renderer: Renderer;
  public viewStyle: string;
  public renderCutoutOutlines = true;
  public cutoutCollision = true;
  public cutoutSnapping = true;
  public onComponentDragStop = new Subject<any>();
  public onComponentSelect = new Subject<any>();
  public onComponentDeselect = new Subject<any>();
  public onCenterClick = new Subject<number>();

  constructor(private ngZone: NgZone) {}

  private _onComponentDragStop(component: any): void {
    this.onComponentDragStop.next(component);
  }

  private _onComponentSelect(component: any): void {
    this.onComponentSelect.next(component);
  }

  private _onComponentDeselect(component: any): void {
    this.onComponentDeselect.next(component);
  }

  private _onCenterClick(): void {
    this.onCenterClick.next(this.renderer.getCurrentZoomLevel().x);
  }

  init(options: RendererOptions): void {
    options.componentDragStop = this._onComponentDragStop.bind(this);
    options.componentSelect = this._onComponentSelect.bind(this);
    options.componentDeselect = this._onComponentDeselect.bind(this);
    options.renderCutoutOutline = this.renderCutoutOutlines;
    options.allowCutoutCollision = this.cutoutCollision;
    options.allowCutoutSnapping = this.cutoutSnapping;
    options.onCenterClick = this._onCenterClick.bind(this);
    this.ngZone.runOutsideAngular(() => {
      this.renderer = new Renderer();
      this.renderer.init(options);
    });
  }

  destroy(): void {
    this.renderer.destroy();
    this.renderer = undefined;
  }

  render(drawing: any): void {
    this.renderer.clear();
    this.renderer.loadFloor(drawing);
    this.setViewStyle(this.viewStyle);
  }

  renderPolyline(xDim: number, yDim: number, numTiers: number): void {
    this.renderer.clear();
    this.renderer.loadPolyline(xDim, yDim, numTiers);
  }

  getImageUrl(): string {
    return this.renderer.getImageUrl();
  }

  setViewStyle(viewStyle: string): void {
    this.viewStyle = viewStyle;
    if (viewStyle === RendererViewStyle.Design) {
      this.renderer.designMode();
    } else if (viewStyle === RendererViewStyle.Diagram) {
      this.renderer.diagramMode();
    }
  }

  setRenderCutoutOutline(renderCutoutOutline: boolean): void {
    this.renderCutoutOutlines = renderCutoutOutline;
    this.renderer.toggleRenderCutoutOutline();
  }

  setAllowCutoutSnapping(allowCutoutSnapping: boolean): void {
    this.cutoutSnapping = allowCutoutSnapping;
    this.renderer.toggleCutoutSnapping();
  }

  setAllowCutoutCollision(allowCutoutCollision: boolean): void {
    this.cutoutCollision = allowCutoutCollision;
    this.renderer.toggleCutoutCollision();
  }
}
